import React from 'react';
import { withStyles, useTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { format_display_date, getTimeInIST } from '../Utils';
import { Grid, Divider, Fade, LinearProgress, TableRow, TableCell, ListItemText, Table, TableHead, TableBody, Hidden } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { WarehouseService } from '../Services/WarehouseService';
import {red, blue} from '@material-ui/core/colors';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles(theme => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    sectionHeading: {
        fontSize: theme.typography.pxToRem(16),
        fontWeight: theme.typography.fontWeightMedium,
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
    },
    subheading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightMedium,
        textAlign: "left"
    },
    redAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: red[500],
    },
    blueAvatar: {
        margin: 10,
        color: '#fff',
        backgroundColor: blue[500],
    },
    row: {
        '&:nth-of-type(odd)': {
          backgroundColor: theme.palette.background.default,
        },
    },
    table: {
        width: "100%",
        "overflowX": "auto" 
    }
}));

const DialogTitle = (props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function TransactionDetailsInformation(props) {
    const [transaction, setTransaction] = React.useState(props.transaction);
    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState(false);

    const [title, setTitle] = React.useState(undefined);
    const [details, setDetails] = React.useState([]); 

    const classes = useStyles();

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    React.useEffect(() => {
        setOpen(props.open);
        setTransaction(props.transaction);
    }, [props.transaction && props.transaction.transaction_id && props.open]);

    const CustomTableCell = withStyles(theme => ({
        head: {
            backgroundColor: theme.palette.primary.dark,
            color: theme.palette.common.white,
        },
        body: {
            fontSize: 14,
            padding: 5
        },
    }))(TableCell);

    React.useEffect(() => {
    if(open && transaction && transaction.transaction_id){
        setLoading(true);
        let details = [];
        console.log("Open", transaction.transaction_id);
        WarehouseService.getTransactionDetail(transaction.transaction_id)
        .then((data) => {
            if(data){
                console.log(data);
                setTitle(`Transaction Details`);

                data.details.forEach((item, i) => {
                    details.push(
                        <TableRow key={i} className={classes.row}>
                            <CustomTableCell padding='none' style={{maxWidth: '2vw'}}>{i + 1}</CustomTableCell>
                            <CustomTableCell  style={{paddingRight: 5, maxWidth: '10vw'}}>
                                <ListItemText 
                                    primary={item.product_display_name ? item.product_display_name : "-"} 
                                    secondary={item.product_name}
                                    style={{paddingRight: 5}}/>
                            </CustomTableCell>
                            <CustomTableCell padding='none'>{item.qty}</CustomTableCell>
                            <CustomTableCell align="right" padding='none'>{item.product_unit}</CustomTableCell>
                            <CustomTableCell align="center">{item.reason_description ? item.reason_description : "-"}</CustomTableCell>
                            <CustomTableCell align="center">{item.comments ? item.comments : "-"}</CustomTableCell>
                        </TableRow>
                    );
                });
                
            }
            setLoading(false);
            setDetails(details);
        })
        .catch((error) => {
            console.log(error);
            setLoading(false);
        });
    }
}, [transaction]);

 
  const handleClose = () => {
    props.close();
    setOpen(false);
    setDetails([]);
  };

  return (
      <Dialog fullScreen={fullScreen} fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle id="customized-dialog-title" onClose={handleClose} classes={classes}>
          {title}
        </DialogTitle>
        <DialogContent dividers>
            <Grid container justify="flex-start" alignItems="center" direction="row">
                <Grid item xs={12} lg={12}>
                    <Fade
                        in={loading}
                        style={{
                            transitionDelay: loading ? '10ms' : '0ms'
                        }}
                        unmountOnExit
                        >
                        <LinearProgress style={{height: 5, width: "100%"}} color="secondary"/>
                    </Fade>
                </Grid>
                {
                    transaction && 
                    <Grid item container spacing={1} style={{flexGrow: 1, marginLeft: 10, marginBottom: 15}} justify="flex-start" alignItems="center">
                        <Grid item xs={6} lg={3}>
                            <Typography variant="subtitle1" className={classes.subheading}>Transaction Date</Typography>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            {getTimeInIST(transaction.txn_date).format(format_display_date)}
                        </Grid>
                        <Hidden xsUp>
                            <Grid item xs={6}/>
                        </Hidden>
                        <Grid item xs={6} lg={3}>
                            <Typography variant="subtitle1" className={classes.subheading}>Stock Type</Typography>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <Typography variant="subtitle1" color={transaction.stock_type === 'FRESH' ? "primary" : "secondary"}>{transaction.stock_type_description}</Typography>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <Typography variant="subtitle1" className={classes.subheading}>Source</Typography>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            {transaction.source_name}
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <Typography variant="subtitle1" className={classes.subheading}>Destination</Typography>
                        </Grid>
                        <Grid item xs={6}  lg={3}>
                            {transaction.destination_name}
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            <Typography variant="subtitle1" className={classes.subheading}>Total Qty</Typography>
                        </Grid>
                        <Grid item xs={6} lg={3}>
                            {transaction.total_qty}
                        </Grid>
                    </Grid>
                }
                <Divider />
                <Table className={classes.table}>
                    <TableHead>
                    <TableRow>
                        <CustomTableCell>Sl.no.</CustomTableCell>
                        <CustomTableCell>Product</CustomTableCell>
                        <CustomTableCell padding='none'>Qty</CustomTableCell>
                        <CustomTableCell align="right" padding='none'>Unit</CustomTableCell>
                        <CustomTableCell align="center">Reason</CustomTableCell>
                        <CustomTableCell align="center">Comments</CustomTableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {details}
                    </TableBody>
                </Table>
            </Grid>
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                    Close
                </Button>
            </DialogActions>
      </Dialog>
  );
}